import { requestFactory } from '@/plugins/axios.js'
// {machineId}
export function getEquipData(data) {
  return requestFactory({
        url: 'machine/findById',
        method: 'POST',
        data: data
      })
}
// {machine}
export function onSubmit(data) {
   return requestFactory({
        url: '/machine/update',
        method: 'POST',
        data: data
      })
}
